/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { CurrentUserResponse } from "../../api/types/swagger-api-types"

export interface CurrentUserPreferences {
    enabledApps: number[] | undefined
    favApps: number[] | undefined
}

// Backend preferences are not structured, we define the structure
// of preferences here.
export type CurrentUser = Omit<CurrentUserResponse, "preferences"> & {
    preferences: CurrentUserPreferences
}

export type Login = {
    username: string
    password: string
    code: string | null
}

export enum LoginStatus {
    Success = "success",
    TotpRequired = "totp_required",
    Error = "error"
}

export type LoginFlowResult =
    | { status: LoginStatus.Success | LoginStatus.TotpRequired }
    | { status: LoginStatus.Error; message: string }
